export default __webpack_public_path__ + "static/media/declineicon.b7773fea.svg";